import React, { useEffect, useState } from "react";
import axios from 'axios';  
import { Trans } from "react-i18next";

function Countdown(props) {
  
  //const start_date = props.startdate;
  const end_date = props.enddate;
  //const end_date = localStorage.getItem('like_enddate');
    const [minscount, setMinscount] = useState(0);

  const calculateTimeLeft = () => {
        
        //console.log("start_date"+props.startdate);
        //console.log("end_date"+end_date);
        var end_dates = new Date(end_date);
        

        var start_date = props.startdate;
        //var start_date = localStorage.getItem('like_startdate');
        
        var offset = minscount * 1000;        
        var datefinal = new Date( +end_dates - offset );     

        const difference = +new Date(datefinal) - +new Date(start_date);         
        
   
        let timeLeft = {};
        let sec = Math.floor((difference / 1000) % 60);
        let s = sec < 10 ? ("0" + sec) : sec;
        let minss = Math.floor((difference / 1000 / 60) % 60);
        let m = minss < 10 ? ("0" + minss) : minss;
        let hourss = Math.floor((difference / (1000 * 60 * 60)) % 24);
        let h = hourss < 10 ? ("0" + hourss) : hourss;

    if (difference > 0) {
      timeLeft = {
        h,
        m,
        s
      };
    }
    else{

        var likecount = new FormData();         
        likecount.set('user_id',JSON.parse(localStorage.getItem('session_userid')));
        
        var api_url = localStorage.getItem('api_url');

        axios({
          method: 'post',
          url: api_url+'updatefreelike',
          data: likecount,
          config: { headers: {'Content-Type': 'multipart/form-data' }}
            })
            .then(res => {

                localStorage.setItem('like_updated', '1');
                window.location.reload();
              
          });
      
    }
  
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft()); 

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
      setMinscount(minscount+1);
    }, 1000);
  });

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
      return;
    }

    timerComponents.push(
      <span>
        {timeLeft[interval]} {interval != 's' ? ':' : '' } {" "}
      </span>
    );
  });
  return (
    <div>
    <div className="text-center">
        <div > 
            <Trans i18nKey="Free like counts starts in">Free like counts starts in </Trans>
        </div>
    </div>
    <div id="timer" class="bold-font">
      {timerComponents.length ? timerComponents : <span>Now you can start to like the profile</span>}
    </div></div>
  );
}

export default Countdown;
